import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ReportEvaluationDisciplineFiltersDTO, ReportEvaluationPracticeFiltersDTO, ReportEvaluationProjectFiltersDTO, ReportEvaluationResourceFiltersDTO, ReportEvaluationOpenProjectFiltersDTO, ReportEvaluationResourcesByDisciplineFiltersDTO } from "../../../domain/models/export-report.model";
import { Resource } from "../../../domain/models/personnel.model";
import { CloseEvaluationResponse, ProjectData, ProjectEvaluationData } from "../../../domain/models/project-evaluation.model";
import { ProjectEvaluationRepository } from "../../../domain/repositories/project-evaluation.repository";
import { ActivePEResponse } from "../hr/hr-impl.repository";

@Injectable()
export class ProjectEvaluationRepositoryImpl extends ProjectEvaluationRepository {
  private readonly endpoint: string = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  override getProjectEvaluation(agreementId: number): Observable<ProjectData> {
    const params: any = { code: agreementId };
    return this.http.get<ProjectData>(`${this.endpoint}/sm/agreementEvaluationInfo`, { params });
  }

  override saveProjectEvaluation(evaluationData: ProjectEvaluationData): Observable<ProjectData> {
    return this.http.post<ProjectData>(`${this.endpoint}/sm/agreementEvaluation`, evaluationData);
  }

  override closeProjectEvaluation(agreementId: number): Observable<boolean> {
    return this.http
      .post<CloseEvaluationResponse>(`${this.endpoint}/sm/closeEvaluation`, { agreementId })
      .pipe(map((res) => res.closeEvaluation.result));
  }

  override searchResources(search?: string): Observable<Resource[]> {
    const params: any = {};
    if (search) params.search = search;
    return this.http
      .get<ActivePEResponse>(`${this.endpoint}/hr/resources`, { params })
      .pipe(map((res) => res.resources));
  }

  override exportDisciplineReport(filters: ReportEvaluationDisciplineFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/discipline`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  override exportPracticeReport(filters: ReportEvaluationPracticeFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/practice`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  override exportResourceReport(filters: ReportEvaluationResourceFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/resource`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  override exportProjectReport(filters: ReportEvaluationProjectFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/project-status`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  // Nuovo metodo per Open Project Report
  override exportOpenProjectReport(filters: ReportEvaluationOpenProjectFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/open-projects`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  override exportResourcesByDisciplineReport(filters: ReportEvaluationResourcesByDisciplineFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.endpoint}/reports/resources-by-discipline`, filters, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}